import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';
import { paths } from '@app/constants';
import { Namespace, usePermissions } from '@data';
import { AntdBreadcrumb, AntdTabs, AntdTypography } from '@ui/components';
import { DeleteQuestion } from './components';
import './styles.css';

const { Text } = AntdTypography;

const Question = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation([Namespace.ADMIN]);
  const { IS_REVIEWER } = usePermissions();

  const navigate = useNavigate();
  const { questionId } = useParams<{ questionId: string }>();
  const { pathname, state } = useLocation();

  // Extract the query params from the location of the previous route
  const previousSearch = state?.from?.search || '';

  const tabs = useMemo(
    () => [
      {
        label: t('question_page.tabs.details'),
        key: `/${paths.app}/${paths.questions_library.root}/${questionId}/${paths.questions_library.details}`,
      },
      {
        label: t('question_page.tabs.classification'),
        key: `/${paths.app}/${paths.questions_library.root}/${questionId}/${paths.questions_library.classification.root}`,
        isNested: true,
      },
      {
        label: t('question_page.tabs.trials'),
        key: `/${paths.app}/${paths.questions_library.root}/${questionId}/${paths.questions_library.trials}`,
      },
      {
        label: t('question_page.tabs.merge'),
        key: `/${paths.app}/${paths.questions_library.root}/${questionId}/${paths.questions_library.merge}`,
      },
      // {
      //   label: t('question_page.tabs.activity'),
      //   key: `/${paths.app}/${paths.questions_library.root}/${questionId}/${paths.questions_library.activity}`,
      // },
    ],
    [language, questionId],
  );

  const breadcrumbs = useMemo(
    () => [
      {
        title: (
          <Link to={`..${previousSearch}`}>
            <Text className="text-base text-gray-600">{t('questions_library.title')}</Text>
          </Link>
        ),
      },
      {
        title: <Text className="text-base font-semibold">{t('question_page.title')}</Text>,
      },
    ],
    [language],
  );

  return (
    <section id="question-page">
      <div className="py-4 px-6 flex items-center justify-between overflow-hidden">
        <AntdBreadcrumb items={breadcrumbs} />
        {!IS_REVIEWER && <DeleteQuestion />}
      </div>
      <AntdTabs
        onChange={(key: string) => navigate(key)}
        className={'w-full px-8 [&>.ant-tabs-nav]:mb-0'}
        activeKey={
          tabs.find(({ key, isNested }) => (isNested ? pathname.includes(key) : pathname === key))
            ?.key
        }
        items={tabs.map(({ key, label }) => ({ key, label }))}
      />
      <Outlet />
    </section>
  );
};

export default Question;
